import { createObservableDataAction, IAction, IActionContext, IAny, ICreateActionContext, IGeneric } from "@msdyn365-commerce/core";
import { getSelectedProductIdFromActionInput, ISelectedProduct, SelectedVariantInput, getSelectedVariantActionDataAction } from "@msdyn365-commerce-modules/retail-actions";
import { cssCapitalize } from "../shared-utils/common-utils";

export class SelectedVariantExtendedInput extends SelectedVariantInput {
    public getCacheKey: () => string = () => 'SelectedVariantExtended';
}

/**
 * CreateInput method for the getSelectedVariant data action.
 * @param inputData - The input data passed to the createInput method.
 * @returns The input for the ata action getSelectedVariantNewAction.
 */
const createInput = (inputData: ICreateActionContext<IGeneric<IAny>>): SelectedVariantExtendedInput => {
    const productId = getSelectedProductIdFromActionInput(inputData);

    if (productId) {
        return new SelectedVariantExtendedInput(
            +productId,
            +inputData.requestContext.apiSettings.channelId,
            undefined,
            undefined,
            inputData.requestContext
        );
    }
    throw new Error('Unable to create SelectedVariantExtendedInput, no productId found on module config or query');
};

async function getSelectedVariantExtendedAction(input: SelectedVariantExtendedInput, context: IActionContext): Promise<ISelectedProduct | null> {
    const result = await getSelectedVariantActionDataAction(input, context);
    if (result?.Name) {
        result.Name = cssCapitalize(result.Name, context.requestContext.locale);
    }
    return result;
}

/**
 * The complete getSelectedVariant data action.
 */
export const getSelectedVariantExtendedActionDataAction = createObservableDataAction({
    id: '@msdyn365-commerce-modules/retail-actions/get-selected-variant-extended',
    action: getSelectedVariantExtendedAction as unknown as IAction<ISelectedProduct | null>,
    input: createInput
});

export default getSelectedVariantExtendedActionDataAction;
